import { regexName } from 'app/utils/validations';
import * as yup from 'yup';

export const schema = yup.object().shape({
  name: yup
    .string()
    .required('El nombre no puede quedar vacío')
    .min(3, 'El nombre debe contener al menos 3 letras')
    .matches(regexName, 'Solo letras y espacios entre nombres'),
  phone: yup
    .string()
    .min(10, 'Verifique que el número tenga 10 cifras al menos')
    .required('El número telefónico no puede quedar vacío'),
  scopes: yup.array().notRequired(),
  status: yup.boolean(),
});
